import ClicksWithFtd from "./ClicksWithFtd";
import ProblematicFtd from "./ProblematicFtd";

import { useSelector } from "react-redux";
import AnomaliesSkeleton2 from "../../AnomaliesSkeleton2";

const AnomaliesFtd = () => {
  const isFetchedForFtdData = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.isFetchedForFtdData,
  );

  return (
    <>
      {isFetchedForFtdData ? (
        <>
          <ClicksWithFtd />
          <ProblematicFtd />
        </>
      ) : (
        <AnomaliesSkeleton2 />
      )}
    </>
  );
};

export default AnomaliesFtd;
